var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop-down',{staticClass:"nav-item",attrs:{"title":_vm.currentLang,"title-classes":"nav-link"}},_vm._l((_vm.langs),function(locale,index){return _c('a',{key:index,staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setCurrentLang(locale)}}},[_vm._v(_vm._s(locale))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }